import React, { useState } from 'react';
import { Dialog } from './Dialog';
import { Button } from './Button';
import { Input } from './Input';

interface LabelQuantityDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (quantity: number) => void;
  loading?: boolean;
  productName?: string;
}

export const LabelQuantityDialog: React.FC<LabelQuantityDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
  productName,
}) => {
  const [quantity, setQuantity] = useState('1');
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = () => {
    const qty = parseInt(quantity, 10);
    if (isNaN(qty) || qty < 1) {
      setError('Quantidade deve ser no mínimo 1');
      return;
    }
    if (qty > 500) {
      setError('Quantidade máxima é 500');
      return;
    }
    setError(null);
    onConfirm(qty);
  };

  const handleClose = () => {
    setQuantity('1');
    setError(null);
    onClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title="Gerar Etiquetas"
      size="sm"
      footer={
        <div className="flex justify-end gap-3">
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            Cancelar
          </Button>
          <Button onClick={handleConfirm} loading={loading}>
            Gerar Etiquetas
          </Button>
        </div>
      }
    >
      <div className="space-y-4">
        {productName && (
          <p className="text-sm text-slate-600">
            Produto: <span className="font-medium text-slate-900">{productName}</span>
          </p>
        )}
        <div>
          <label htmlFor="label-quantity" className="block text-sm font-medium text-slate-700 mb-1">
            Quantidade de etiquetas
          </label>
          <Input
            id="label-quantity"
            type="number"
            min={1}
            max={500}
            value={quantity}
            onChange={(e) => {
              setQuantity(e.target.value);
              setError(null);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleConfirm();
            }}
            placeholder="1"
          />
          {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
          <p className="mt-1 text-xs text-slate-500">Mínimo: 1 — Máximo: 500</p>
        </div>
      </div>
    </Dialog>
  );
};
